import { makeId } from '@/utils/makeId'

export type Batter = {
  id: string
  name: string
  price: number
}

export const batters: Batter[] = [
  {
    id: makeId(),
    name: 'Baunilha',
    price: 69.99,
  },
  {
    id: makeId(),
    name: 'Chocolate',
    price: 79.99,
  },
]
